module.exports = __webpack_public_path__ + "assets/images/icons/icon_seat.svg?v=2d9c30ae";